module.exports = __webpack_public_path__ + "static/img/icon1-active.15b581a1.svg";